import { defineMessages } from 'react-intl';

export const continueOnMobileCardMessages = defineMessages({
  title: {
    defaultMessage: 'Approve from your phone',
    id: 'D2aP8qBgXY',
    description:
      'Title of the card in Work chat suggesting the Heidi mobile app while the agent waits on an approval',
  },
  subtitle: {
    defaultMessage: 'Get the Heidi app. We’ll notify you when Heidi needs your input.',
    id: 'nZptYLX0wA',
    description:
      'Supporting sentence of the card in Work chat suggesting the Heidi mobile app while the agent waits on an approval',
  },
  getTheApp: {
    defaultMessage: 'Get the app',
    id: 'KfdRGrnLff',
    description:
      'Button on the Work chat mobile app card that opens the QR code to download the Heidi mobile app',
  },
  dismiss: {
    defaultMessage: 'Dismiss',
    id: 'S9AIuEmbmQ',
    description:
      'Accessible label of the X button that hides the Work chat mobile app card for a week',
  },
});
